import "core-js/modules/es.array.push.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "supplies_box"
};
var _hoisted_2 = {
  class: "search_header",
  style: {
    "width": "400px",
    "margin-bottom": "10px"
  }
};
var _hoisted_3 = {
  class: "search_contain"
};
var _hoisted_4 = {
  class: "search_box",
  id: "search_box"
};
var _hoisted_5 = {
  class: "pagination_"
};
var _hoisted_6 = {
  class: "dialog-footer"
};
import { ref, watch, watchEffect, onMounted, nextTick } from "vue";
import { get_business_trip } from "@/api/apis";
import { useRoute, useRouter } from "vue-router";
export default {
  __name: 'selectTripDailog',
  props: ["isShow", "trip", "userID"],
  emits: ["closeDialog", "handleChoose"],
  setup(__props, _ref) {
    var {
      emit: __emit
    } = _ref;
    var router = useRouter();
    var dialogVisible = ref(false);
    var props = __props;
    var emit = __emit;
    var search = () => {
      if (dialogVisible.value) {
        wl_fy.value.page = 1;
        getList();
      }
    };
    var multipleTableRef = ref(null);
    var wl_fy = ref({
      page: 1,
      limit: 10,
      total: 0
    });
    var tripList = ref([]);
    var checkList = ref([]);
    var checkedItems = ref(new Set());
    var key_word = ref("");
    var get_row = row => {
      return row.id;
    };
    var toggleCheck = () => {
      var _tripList$value;
      if (!((_tripList$value = tripList.value) !== null && _tripList$value !== void 0 && _tripList$value.length)) return;
      // 获取所有已选中项的 ID（包括其他页面的）
      var allCheckedIds = Array.from(checkedItems.value);
      if (!allCheckedIds.length) return;
      nextTick(() => {
        try {
          tripList.value.forEach(row => {
            if (allCheckedIds.includes(row.id)) {
              var _multipleTableRef$val;
              (_multipleTableRef$val = multipleTableRef.value) === null || _multipleTableRef$val === void 0 || _multipleTableRef$val.toggleRowSelection(row, true);
            }
          });
        } catch (error) {
          console.warn("设置表格选中状态时出错:", error);
        }
      });
    };
    var handleSelectionChange = selectedRows => {
      // 更新当前页面的选中项
      checkList.value = [...selectedRows];
      var currentAllCheckedIds = Array.from(checkedItems.value);
      tripList.value.forEach(row => {
        var index = currentAllCheckedIds.indexOf(row.id);
        if (index > -1) {
          currentAllCheckedIds.splice(index, 1);
        }
      });
      checkedItems.value.clear();
      currentAllCheckedIds.forEach(id => checkedItems.value.add(id));
      selectedRows.forEach(row => {
        checkedItems.value.add(row.id);
      });
      console.log("checkedItems updated:", Array.from(checkedItems.value));
    };
    var handle_close = () => {
      dialogVisible.value = false;
      emit("closeDialog");
    };
    var handle_checked = () => {
      dialogVisible.value = false;
      emit("handleChoose", checkList.value);
    };
    var handleCurrentChange = () => {
      getList();
    };
    // 创建节流搜索函数
    var searchTimer = null;
    var throttledSearch = () => {
      if (searchTimer) {
        clearTimeout(searchTimer);
      }
      searchTimer = setTimeout(() => {
        if (dialogVisible.value) {
          wl_fy.value.page = 1;
          getList();
        }
      }, 300);
    };
    var getList = () => {
      var obj = {
        business_no: key_word.value,
        page: wl_fy.value.page,
        limit: wl_fy.value.limit,
        user_id: props.userID,
        status: 4,
        is_used: 1 //1、是未使用 2、已使用过的
      };
      get_business_trip(obj).then(res => {
        if (res.code == 200) {
          wl_fy.value.total = res.data.total;
          tripList.value = res.data.list || [];
          // 数据加载完成后执行选中操作
          nextTick(() => {
            toggleCheck();
          });
        }
      });
    };
    watchEffect(() => {
      dialogVisible.value = props.isShow;
    });
    onMounted(() => {});

    // 监听对话框显示状态
    watch(() => dialogVisible.value, newVal => {
      if (newVal) {
        wl_fy.value.page = 1;
        key_word.value = ""; // 清空搜索关键词
        getList();
      } else {
        emit("closeDialog");
      }
    }, {
      immediate: true,
      deep: true
    });
    watch(() => key_word.value, (newVal, oldVal) => {
      // 只有当关键词实际改变时才执行搜索
      if (newVal !== oldVal) {
        throttledSearch();
      }
    });
    // 监听props.trip变化
    watch(() => props.trip, newTrip => {
      var _tripList$value2;
      console.log({
        newTrip
      });
      if (newTrip !== null && newTrip !== void 0 && newTrip.length) {
        // 初始化时，将所有传入的选中项添加到 checkedItems 中
        newTrip.forEach(item => {
          var id = item.origin_id;
          if (id) {
            checkedItems.value.add(id);
          }
        });
        checkList.value = [...newTrip];
      } else {
        checkedItems.value.clear();
        checkList.value = [];
      }

      // 如果对话框已显示且有数据，执行选中操作
      if (dialogVisible.value && (_tripList$value2 = tripList.value) !== null && _tripList$value2 !== void 0 && _tripList$value2.length) {
        nextTick(() => {
          toggleCheck();
        });
      }
    }, {
      immediate: true,
      deep: true
    });

    // 监听checkList变化
    watch(() => checkList.value, (newVal, oldVal) => {
      var _tripList$value3;
      var newCheckList = newVal ? [...newVal] : [];
      if (!newCheckList.length) {
        nextTick(() => {
          var _multipleTableRef$val2;
          (_multipleTableRef$val2 = multipleTableRef.value) === null || _multipleTableRef$val2 === void 0 || _multipleTableRef$val2.clearSelection();
        });
      } else if (dialogVisible.value && (_tripList$value3 = tripList.value) !== null && _tripList$value3 !== void 0 && _tripList$value3.length) {
        toggleCheck();
      }
    }, {
      deep: true
    });

    // 监听tripList变化
    watch(() => tripList.value, newList => {
      if (newList !== null && newList !== void 0 && newList.length && dialogVisible.value) {
        toggleCheck();
      }
    }, {
      deep: true
    });
    var toAdd = () => {
      router.push("/work_bench/entertainment_edit");
    };
    return (_ctx, _cache) => {
      var _component_el_input = _resolveComponent("el-input");
      var _component_el_button = _resolveComponent("el-button");
      var _component_el_table_column = _resolveComponent("el-table-column");
      var _component_el_table = _resolveComponent("el-table");
      var _component_el_pagination = _resolveComponent("el-pagination");
      var _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        "destroy-on-close": true,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => dialogVisible.value = $event),
        title: "请选择出差单",
        style: {
          "width": "60%"
        },
        onClose: handle_close
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_button, {
          onClick: handle_close
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("取消")])),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handle_checked
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode(" 确定 ")])),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
          modelValue: key_word.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => key_word.value = $event),
          placeholder: "出差单号"
        }, null, 8, ["modelValue"]), _cache[4] || (_cache[4] = _createTextVNode("   ")), _createVNode(_component_el_button, {
          type: "primary",
          onClick: search
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("查询")])),
          _: 1
        })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_table, {
          data: tripList.value,
          style: {
            "height": "100%"
          },
          "row-key": get_row,
          ref_key: "multipleTableRef",
          ref: multipleTableRef,
          border: "",
          "cell-style": {
            padding: '3px 0'
          },
          onSelectionChange: handleSelectionChange
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            type: "selection",
            "reserve-selection": ""
          }), _createVNode(_component_el_table_column, {
            prop: "business_no",
            label: "出差单号",
            "show-overflow-tooltip": "",
            width: "180px",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            prop: "company_name",
            label: "所属公司",
            "show-overflow-tooltip": "",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            prop: "reason",
            label: "出差事由",
            "show-overflow-tooltip": "",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            prop: "travel_time",
            label: "出差时间",
            "show-overflow-tooltip": "",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            prop: "business_trip_day",
            label: "出差天数（天）",
            "show-overflow-tooltip": "",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            prop: "created_at",
            label: "申请时间",
            "show-overflow-tooltip": "",
            align: "center"
          }), _createVNode(_component_el_table_column, {
            prop: "user_name",
            label: "申请人",
            "show-overflow-tooltip": "",
            align: "center"
          })]),
          _: 1
        }, 8, ["data"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_pagination, {
          "current-page": wl_fy.value.page,
          "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => wl_fy.value.page = $event),
          background: "",
          layout: "total,prev, pager, next",
          "page-size": wl_fy.value.limit,
          total: wl_fy.value.total,
          onCurrentChange: handleCurrentChange,
          small: ""
        }, null, 8, ["current-page", "page-size", "total"])])])])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
};